export const changeSelectedDatatypeReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_Selecteddatatype":
      return action.payload.selecteddatatype;
    default:
      return state;
  }
};
